import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/icons/gross-earnings.svg'


const _hoisted_1 = { class: "trezo-card bg-purple-100 dark:bg-[#0c1427] mb-[25px] p-[20px] md:p-[25px] rounded-md" }
const _hoisted_2 = { class: "trezo-card-content" }
const _hoisted_3 = { class: "-mt-[15px] -mb-[8px]" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_apexchart = _resolveComponent("apexchart")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[0] || (_cache[0] = _createStaticVNode("<div class=\"flex items-center\"><img src=\"" + _imports_0 + "\" alt=\"gross-earnings\"><div class=\"ltr:ml-[10px] rtl:mr-[10px]\"><span class=\"block uppercase\"> Gross Earnings </span><h4 class=\"mb-0 text-[20px] mt-[6px] font-semibold\"> $78,350.00 <span class=\"text-success-600 text-base font-medium -top-px relative ltr:ml-[2px] rtl:mr-[2px] ltr:pl-[25px] rtl:pr-[25px]\"><i class=\"material-symbols-outlined !text-[20px] absolute ltr:left-0 rtl:right-0 top-1/2 -translate-y-1/2\"> trending_up </i> +2.3% </span></h4></div></div>", 1)),
      _createElementVNode("div", _hoisted_3, [
        (_ctx.isClient)
          ? (_openBlock(), _createBlock(_component_apexchart, {
              key: 0,
              type: "line",
              height: "245",
              options: _ctx.grossEarnings,
              series: _ctx.earnings
            }, null, 8, ["options", "series"]))
          : _createCommentVNode("", true)
      ]),
      _cache[1] || (_cache[1] = _createStaticVNode("<div class=\"flex justify-between pt-[17px] border-t border-purple-200 dark:border-[#172036]\"><div><span class=\"block text-xs\"> Total Balance </span><h6 class=\"mb-0 font-medium text-lg mt-[5px]\">$3,42,890</h6></div><div><span class=\"block text-xs\"> Withdrawals </span><h6 class=\"mb-0 font-medium text-lg mt-[5px]\">$2,35,425</h6></div></div>", 1))
    ])
  ]))
}